module.exports = __webpack_public_path__ + "img/c07_unitberserker_Normal_ua.df213952.webp";